import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { useContext, useState } from "react";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import Select from "react-select";
import measurementTypes from "../../resources/json/measurementTypes.json";
import {Consts} from "../pages/consts";

const Measurement = ({
  selectedPatient,
  onSaveNewMeasurement,
  showDialog,
  hcpView,
}) => {
  const { t: t } = useTranslation();
  const [measurementValues, setMeasurementValues] = useState([]);
  const [selectedMeasurementType, setSelectedMeasurementType] = useState({});
  const context = useContext(InitContext);
  const [startDate, setStartDate] = useState();
  const { loading, error, clearError, saveDbMeasurement } = useMmcService();

  const handleSaveMeasurement = () => {
    clearError();
    const params = [];

    measurementValues?.forEach((measurementValue, i) => {
      if (measurementValue) {
        params?.push({
          name: selectedMeasurementType?.value?.params[i],
          value: measurementValue,
          unit: selectedMeasurementType?.value?.units[i],
        });
      }
    });

    const measurementToSave = {
      name: selectedMeasurementType?.label,
      dateTime: startDate,
      params: params,
    };

    const patientId = !selectedPatient
      ? context?.patient?.id
      : selectedPatient?.id;

    saveDbMeasurement(context?.token, patientId, measurementToSave).then(() => {
      onSaveNewMeasurement(measurementToSave);
    });
  };

  const checkRequiredFields = () => {
    return (
      selectedMeasurementType &&
      startDate &&
      measurementValues?.length > 0
    );
  };

  const handleSelectMeasurementType = async (measurementType) => {
    setSelectedMeasurementType(measurementType);
    setMeasurementValues(null);
  };

  const handleSettingParamValue = async (value, index) => {
    setMeasurementValues((previousValues) => {
      let updatedValues = previousValues ? [...previousValues] : []; // initial array

      if(value){ // if value is not empty, set it
        updatedValues[index] = value;
      } else { // if value is empty, it means that the existing value on this place should be deleted
        if(previousValues) { // check if the array already has items
          updatedValues = previousValues?.filter((item, i) => i !== index); // delete the existing value
        }
      }

      return updatedValues;
    });
  };

  const errorMessage = error && (
    <ErrorMessage message={t("error_by_saving_a_measurement")} />
  );

  const spinner = loading && <Spinner />;

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 dialog-medium">
        <Formik
          initialValues={{
            name: "",
            dateTime: "",
            comment: "",
          }}
          onSubmit={handleSaveMeasurement}
        >
          {({}) => (
            <Form>
              <header className="w3-container w3-center w3-padding-small">
                <h2>
                  {hcpView
                    ? t("please_enter_the_measurement_data")
                    : t("please_enter_your_measurement_data")}
                </h2>
              </header>
              {errorMessage}
              {spinner}
              <div className="w3-row w3-padding-small">
                <div className="w3-third">
                  <label>{t("measurement")}</label>
                </div>
                <div className="w3-twothird">
                  <Select
                    id="name"
                    options={measurementTypes}
                    onChange={(measurementType) =>
                      handleSelectMeasurementType(measurementType)
                    }
                    formatOptionLabel={(measurementType) =>
                      t(measurementType.label)
                    }
                    placeholder={t("select")}
                    className="custom-select"
                    classNamePrefix="custom-select"
                  />
                </div>
              </div>
              <div className="w3-row w3-padding-small">
                <div className="w3-third ">
                  <label>{t("measurement_date")}:</label>
                </div>
                <div className="w3-twothird">
                  <input
                    id={Consts.DATE}
                    type={Consts.DATE}
                    className="w3-input w3-border w3-round form-input"
                    onChange={(event) => setStartDate(event.target.value)}
                  />
                </div>
              </div>
              {selectedMeasurementType?.value?.params?.map((param, i) => {
                return (
                  <div
                    className="w3-row w3-padding-small"
                    key={`param${selectedMeasurementType.label}${i}`}
                  >
                    <label className="w3-third">{t(param)}:</label>
                    <input
                      id={Consts.VALUE}
                      name={Consts.VALUE}
                      type={Consts.NUMBER}
                      min="0"
                      className="form-input w3-margin-right"
                      defaultValue={
                        measurementValues ? measurementValues[i] : ""
                      }
                      onChange={(event) =>
                        handleSettingParamValue(event.target.value, i)
                      }
                      step="0.01"
                    />
                    <label>{t(selectedMeasurementType?.value?.units[i])}</label>
                  </div>
                );
              })}
              <footer className="w3-container w3-center w3-padding-small">
                <div className="w3-right w3-padding-small">
                  <button
                    type="submit"
                    className="w3-btn w3-round-xlarge w3-theme-d5"
                    disabled={!checkRequiredFields()}
                  >
                    {t("submit")}
                  </button>
                  <button
                    onClick={() => onSaveNewMeasurement(null)}
                    className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin"
                    type="text"
                  >
                    {t("cancel")}
                  </button>
                </div>
              </footer>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Measurement;
